export { default as ArrowDownTriangleSolidIcon } from './ArrowDownTriangleSolidIcon';
